export const CLEAN_FORM = 'fuerzaventas/gestionroles/clean-form';
export const ADVANCED_SEARCH_CLOSE = 'main/advanced-search-close';
export const ADVANCED_SEARCH_OPEN = 'main/advanced-search-open';
export const SET_STATE_FORM = 'fuerzaventas/gestionroles/set-state-form';
export const UPDATE_FIELD_FILTER = 'fuerzaventas/gestionroles/update-field-filter';
export const RECEIVE_V_LIST = 'fuerzaventas/gestionroles/receive-v-list';
export const REQUEST_V_LIST = 'fuerzaventas/gestionroles/request-v-list';
export const ERROR_V_LIST = 'fuerzaventas/gestionroles/error-v-list';
export const SET_MASK = 'fuerzaventas/gestionroles/set-mask';
export const SET_ORDER = 'fuerzaventas/gestionroles/set-order';
export const RECEIVE_DATA= 'fuerzaventas/gestionroles/receibe-data';
export const UPDATE_TABLE_COLUMN= 'fuerzaventas/gestionroles/update-table-column';
export const SET_PAGE = 'fuerzaventas/gestionroles/set-page';
export const SET_PAGE_SIZE = 'fuerzaventas/gestionroles/set-page-size';
export const SET_SELECTED_ROW = 'fuerzaventas/gestionroles/set-selected-row';
export const UPDATE_FIELD_ENTITY = 'fuerzaventas/gestionroles/update-field-entity';
export const SET_ERROR = 'fuerzaventas/gestionroles/set-error';

export const ADD_OLA = 'fuerzaventas/gestionroles/add_ola';
export const ADD_DISTRIBUIDOR = 'fuerzaventas/gestionroles/add_distribuidor';